module.exports = __webpack_public_path__ + "static/media/cloud-upload-alt.6e376f33.svg";